<div class="dap-admin">
  <ion-card>
    <ion-card-header>
      <ion-card-title>DÁP-csatlakozás (eAzonosítás)</ion-card-title>
      <ion-card-subtitle>
        A DÁP mobilalkalmazással való belépéshez az intézmény a SZEÜSZ-ön regisztrál, környezetenként
        (sandbox → tesztkörnyezet → éles). A kérelemhez tanúsítványkérelmet kell csatolni: ezeket itt
        készíti el a rendszer. A kulcspár a szerveren marad, így nem veszhet el a saját gépeden.
      </ion-card-subtitle>
    </ion-card-header>

    <ion-card-content>
      <ion-segment [(ngModel)]="kornyezet" class="kornyezet">
        <ion-segment-button *ngFor="let k of kornyezetek" [value]="k.kulcs"><ion-label>{{ k.nev }}</ion-label></ion-segment-button>
      </ion-segment>
      <p class="halvany" *ngIf="kornyezet === 'sandbox'">
        Sandboxban két kérelem kell: a <b>klienstanúsítványé</b> (ezzel éred el a böngészős teszttárcát) és az
        <b>aláíró (bélyegző) tanúsítványé</b>. Mindkettőt az IdomSoft állítja ki.
      </p>
      <p class="halvany" *ngIf="kornyezet !== 'sandbox'">
        Itt csak az <b>aláíró (bélyegző) tanúsítvány</b> kell, és azt nem az IdomSoft, hanem egy piaci bizalmi
        szolgáltató állítja ki (az IdomSoft hozzájáruló nyilatkozatával). A kérelmet ide is a rendszer készíti.
      </p>

      <h3 class="cim">A tanúsítványkérelem adatai</h3>
      <ion-grid class="mezok">
        <ion-row>
          <ion-col size="12" sizeMd="6">
            <ion-input label="A csatlakozó rendszer egyedi azonosítója (domain)" label-placement="stacked" [(ngModel)]="adat.domain"
                       placeholder="idp.sulinform.iskola.hu"></ion-input>
          </ion-col>
          <ion-col size="12" sizeMd="6">
            <ion-input label="Szervezet" label-placement="stacked" [(ngModel)]="adat.o" maxlength="64"></ion-input>
          </ion-col>
          <ion-col size="6" sizeMd="2"><ion-input label="Ország" label-placement="stacked" [(ngModel)]="adat.c" maxlength="2"></ion-input></ion-col>
          <ion-col size="6" sizeMd="3"><ion-input label="Megye" label-placement="stacked" [(ngModel)]="adat.st" maxlength="64"></ion-input></ion-col>
          <ion-col size="6" sizeMd="4"><ion-input label="Település" label-placement="stacked" [(ngModel)]="adat.l" maxlength="64"></ion-input></ion-col>
          <ion-col size="6" sizeMd="3"><ion-input label="Szervezeti egység" label-placement="stacked" [(ngModel)]="adat.ou" maxlength="64"></ion-input></ion-col>
        </ion-row>
      </ion-grid>
      <p class="halvany">
        A domainre kell mutatnia a DÁP-belépés címének (a kérelem SAN DNS mezője és a <code>client_id</code> is ez lesz).
        A tanúsítványba ékezet nélkül kerülnek az adatok.
      </p>
      <div class="gombok">
        <ion-button (click)="kerelmekKeszitese()" [disabled]="keszul || betolt || !adat.domain || !adat.o">
          <ion-icon slot="start" name="key-outline"></ion-icon>
          {{ keszul ? 'Készül…' : (aktiv?.kell?.length === 2 ? 'Kulcspárok és kérelmek elkészítése' : 'Kulcspár és kérelem elkészítése') }}
        </ion-button>
      </div>

      <h3 class="cim">Kitöltési segéd – SZEÜSZ-űrlap, „E-azonosítás” ({{ aktiv?.nev }})</h3>
      <table class="segéd">
        <tr>
          <th>A csatlakozó rendszer egyedi azonosítója</th>
          <td><code>{{ adat.domain || '—' }}</code></td>
          <td class="muvelet"><ion-button size="small" fill="clear" (click)="masol(adat.domain)" [disabled]="!adat.domain">Másolás</ion-button></td>
        </tr>
        <tr>
          <th>A csatlakozó rendszer teljes megnevezése</th>
          <td><ion-input [(ngModel)]="rendszerNev" class="beagyazott"></ion-input></td>
          <td class="muvelet"><ion-button size="small" fill="clear" (click)="masol(rendszerNev)">Másolás</ion-button></td>
        </tr>
        <tr *ngFor="let s of aktiv?.kell || []">
          <th>{{ szerepNev(s) }}</th>
          <td>
            <ng-container *ngIf="legfrissebb(s) as k; else nincsKerelem">
              {{ k.domain }} · {{ k.letrehozva | date:'yyyy.MM.dd. HH:mm' }}
            </ng-container>
            <ng-template #nincsKerelem><span class="hianyzik">még nincs – készítsd el fent</span></ng-template>
          </td>
          <td class="muvelet">
            <ion-button size="small" fill="clear" *ngIf="legfrissebb(s) as k" (click)="kerelemLetoltes(k)">
              <ion-icon slot="start" name="download-outline"></ion-icon>.p10
            </ion-button>
          </td>
        </tr>
      </table>

      <h3 class="cim" *ngIf="lista.length">Kulcsok és tanúsítványok – {{ aktiv?.nev }}</h3>
      <div class="kulcs" *ngFor="let k of lista" [class.van]="k.tanusitvany && !k.tanusitvany.lejart">
        <div class="fej">
          <b>{{ k.szerep_nev }}</b> · <code>{{ k.domain }}</code>
          <span class="halvany"> · kérelem: {{ k.letrehozva | date:'yyyy.MM.dd. HH:mm' }}{{ k.letrehozta ? ', ' + k.letrehozta : '' }}</span>
        </div>
        <div class="allapot" *ngIf="k.tanusitvany as t; else varTan">
          Tanúsítvány: érvényes {{ t.ervenyes_tol | date:'yyyy.MM.dd.' }} – {{ t.ervenyes_ig | date:'yyyy.MM.dd.' }}
          <span class="lejart" *ngIf="t.lejart"> (LEJÁRT)</span>
          <span class="figyel" *ngIf="t.hamarosan_lejar"> (30 napon belül lejár)</span>
          <br><span class="halvany">Kiadó: {{ t.kiado }} · {{ t.san }} · lánc: {{ t.lanc_db }} tanúsítvány</span>
        </div>
        <ng-template #varTan><div class="allapot var">A kiállított tanúsítvány még nincs feltöltve.</div></ng-template>
        <div class="gombok">
          <ion-button size="small" fill="outline" (click)="kerelemLetoltes(k)">
            <ion-icon slot="start" name="download-outline"></ion-icon>Kérelem (.p10)
          </ion-button>
          <ion-button size="small" fill="outline" (click)="fajl.click()" [disabled]="fut[k.id]">
            <ion-icon slot="start" name="cloud-upload-outline"></ion-icon>{{ k.tanusitvany ? 'Tanúsítvány cseréje' : 'Kiállított tanúsítvány feltöltése' }}
          </ion-button>
          <input #fajl type="file" hidden accept=".pem,.crt,.cer,.der,.p7b,.p7c" (change)="tanusitvanyFeltoltes(k, $event)">
          <ion-button size="small" fill="outline" *ngIf="k.szerep === 'kliens' && k.tanusitvany" (click)="p12(k)" [disabled]="fut[k.id]">
            <ion-icon slot="start" name="key-outline"></ion-icon>Böngészőbe (.p12)
          </ion-button>
          <ion-button size="small" fill="clear" color="danger" *ngIf="!k.tanusitvany" (click)="torles(k)">Törlés</ion-button>
        </div>
      </div>
    </ion-card-content>
  </ion-card>
</div>
